module.exports = __webpack_public_path__ + "static/img/donation.404ecf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/donation.png
// module id = ON9n
// module chunks = 1